import { createLocationStore, locationFrame } from './device-map-model'

// 初始位置不依赖WS成功；WS就绪后再补一次快照，填平建连期间的事件空窗。
export function createLocationFeed ({ query, stream, snapshot, changed, status, later = setTimeout, cancel = clearTimeout }) {
  const store = createLocationStore(query)
  let closed = false, subscription, timeout, paint, loading = false, pending = createLocationStore(query), rerun = false
  let initialized = false, streamReady = false, streamFault = null, revision = 0, epoch = 0
  let positionUpdates = new Set()
  const unsubscribe = () => { if (subscription) { try { subscription.unsubscribe() } catch (_) { /* 连接可能已关闭 */ } subscription = null } }
  const report = () => status(streamFault ? 'error' : streamReady ? 'ready' : 'connecting', streamFault && streamFault.message, streamFault)
  const publish = (source = 'snapshot') => {
    if (!closed) { changed(store.rows(), { source, positionUpdates: source === 'realtime' ? Array.from(positionUpdates) : [] }); positionUpdates.clear(); report() }
  }
  const fail = error => {
    if (closed) return
    closed = true; cancel(timeout); cancel(paint); unsubscribe(); pending = null
    if ([401, 403].includes(error && error.status)) changed([])
    status('error', error && error.message || '地图位置读取失败', error)
  }
  const streamFailed = error => {
    if (closed || streamFault) return
    error = error || new Error('地图实时位置连接失败，正在自动重连')
    streamReady = false; streamFault = error; cancel(timeout); unsubscribe()
    if ([401, 403].includes(error && error.status)) { fail(error); return }
    // 不让重试反复取消尚未返回的初始慢查询。
    if (initialized && !loading) report()
  }
  const refresh = async () => {
    if (closed) return
    if (loading) { rerun = true; return }
    loading = true
    const expectedEpoch = epoch
    if (!initialized) status('loading')
    try {
      const frame = locationFrame(await snapshot())
      if (closed) return
      if (expectedEpoch !== epoch) { rerun = true; return }
      if (frame.kind !== 'snapshot') throw new Error('地图位置快照返回无效')
      store.snapshot(frame.points, pending.changes(), initialized); pending = createLocationStore(query); initialized = true; publish()
    } catch (error) { fail(error) }
    finally { loading = false; if (rerun && !closed) { rerun = false; refresh() } }
  }
  const receive = response => {
    if (closed || streamFault) return
    try {
      const frame = locationFrame(response && response.payload)
      if (!Number.isSafeInteger(frame.revision) || frame.revision < 1) throw new Error('地图实时范围版本无效')
      if (frame.revision < revision) return
      if (frame.kind === 'ready') {
        if (streamReady && frame.revision === revision) return
        const changedScope = revision > 0 && revision !== frame.revision
        revision = frame.revision; streamReady = true; cancel(timeout)
        if (changedScope) { epoch++; initialized = false; pending = createLocationStore(query); cancel(paint); paint = null; changed([]) }
        refresh(); return
      }
      if (frame.kind === 'resync') { revision = frame.revision; epoch++; initialized = false; pending = createLocationStore(query); cancel(paint); paint = null; changed([]); refresh(); return }
      if (frame.kind !== 'changes') throw new Error('地图实时消息类型无效')
      if (loading || !initialized) {
        // 按设备合并首屏等待期间的最新位置/连接状态，不因同一设备重复上报堆满原始帧。
        frame.changes.forEach(pending.change)
      } else {
        frame.changes.forEach(change => { store.change(change); if (change.kind !== 'state') positionUpdates.add(change.deviceId) })
        if (!paint) paint = later(() => { paint = null; publish('realtime') }, 100)
      }
    } catch (error) { fail(error) }
  }
  status('loading')
  timeout = later(() => streamFailed(new Error('地图位置订阅超时，正在自动重连')), 15000)
  try {
    if (stream.onReconnect) stream.onReconnect(() => {
      if (closed) return
      epoch++; initialized = false; streamReady = false; streamFault = null; revision = 0; pending = createLocationStore(query)
      cancel(paint); paint = null; changed([])
      cancel(timeout); timeout = later(() => streamFailed(new Error('地图位置订阅超时，正在自动重连')), 15000)
      refresh()
    })
    const value = stream.subscribe(receive, streamFailed, () => streamFailed(new Error('地图位置订阅已结束，正在自动重连')))
    subscription = value
    if (closed || streamFault) unsubscribe()
  } catch (error) { streamFailed(error) }
  if (!loading && !closed) refresh()
  return { close () {
    closed = true; cancel(timeout); cancel(paint); pending = null
    unsubscribe()
  } }
}
